// Hook partagé Gouvernance — fetch des 5 sources (gatekeeper, policy,
// tickets, evaluations, gamora, nebula). Chaque widget choisit ce dont
// il a besoin via les clés du dict retourné.
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

function authHeaders() {
  const token = localStorage.getItem("session_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function useGovernanceData() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const headers = authHeaders();
        const [gkR, policyR, ticketsR, evalsR, gamoraR, nebulaR] = await Promise.all([
          fetch(`${API}/api/groot/gatekeeper/status`, { headers }),
          fetch(`${API}/api/policy/rules/stats`, { headers }),
          fetch(`${API}/api/oh/tickets/stats/overview`, { headers }),
          fetch(`${API}/api/policy/evaluations/stats`, { headers }),
          fetch(`${API}/api/governance/gamora/latest`, { headers }),
          fetch(`${API}/api/nebula/latest`, { headers }),
        ]);
        const next = {};
        if (gkR.ok) next.gatekeeper = await gkR.json();
        if (policyR.ok) next.policy = (await policyR.json()).stats;
        if (ticketsR.ok) next.tickets = await ticketsR.json();
        if (evalsR.ok) next.evaluations = (await evalsR.json()).stats;
        if (gamoraR.ok) next.gamora = (await gamoraR.json()).report;
        if (nebulaR.ok) next.nebula = (await nebulaR.json()).report;
        if (!cancelled) setData(next);
      } catch (e) {
        if (!cancelled) console.error("governance fetch:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { data, loading };
}
